import { get, isEmpty } from "lodash";
import { blogPage } from "grandus-lib/utils/fetches";

import styles from "./detail.page.module.scss";

import Link from "next/link";
import Breadcrumbs from "components/breadcrumbs/Breadcrumbs";
import Image from "grandus-lib/components-atomic/image/Image";
import { Divider } from "antd";
import LockedMessage from "components/blog/lockedMessage/LockedMessage";
import useUser from "grandus-lib/hooks/useUser";
import MetaData from "grandus-lib/components-atomic/MetaData";

const BlogDetail = (props) => {
  const { blog } = props;
  const { user } = useUser();
  const breadcrumbsData = {
    childrens: [
      {
        name: "Blog",
        href: `/blog`,
      },
      {
        name: blog?.category?.name,
        href: `/blog/kategoria/${blog?.category?.id}/${blog?.category?.urlName}`,
      },
    ],
  };
  const meta = {
    title: get(blog, "title"),
    description: get(blog, "perex"),
    photo: get(blog, "photo", {}),
  };
  return (
    <main className={"container guttered"}>
      <MetaData {...meta} />
      <Breadcrumbs data={breadcrumbsData} current={get(blog, "title")} />
      <div className={`${styles?.blogDetail}`}>
        <ul className={styles?.info}>
          <li>
            <Link
              href="/blog/kategoria/[id]/[[...category]]"
              as={`/blog/kategoria/${blog?.category?.id}/${blog?.category?.urlTitle}`}
            >
              <a>{blog?.category?.name}</a>
            </Link>
          </li>
        </ul>
        <h1>{get(blog, "title")}</h1>
        {blog?.photo ? (
          <Image
            photo={get(blog, "photo", {})}
            size={"1220x680__cropped"}
            type={"jpg"}
          />
        ) : null}
        <Divider />
        <div
          dangerouslySetInnerHTML={{
            __html: get(blog, "text", ""),
          }}
        />
        {isEmpty(user) && blog?.isLocked ? <LockedMessage /> : null}
      </div>
    </main>
  );
};

export async function getServerSideProps(context) {
  return blogPage.serverSideProps(context);
}

export default BlogDetail;
